<template>
  <div class="page-content">
    <h1>{{ $route.meta.title }}</h1>

    <el-form
      ref="orderStatusForm"
      class="border-container"
      :inline="true"
      :model="formData"
    >
      <div class="order-info-section">
        <h2 class="title"><span>特殊操作</span></h2>

        <div class="action-bar">
          <el-radio-group v-model="formData.hasReason">
            <el-radio
              :label="1"
              @change="$set(formData, 'cancelReason', '乘客取消')"
            >
              乘客取消
            </el-radio>
            <el-radio
              :label="2"
              @change="$set(formData, 'cancelReason', '乘客爽約')"
            >
              乘客爽約
            </el-radio>
            <el-radio :label="3">
              其他
              <el-input v-model="formData.cancelReason"></el-input>
            </el-radio>
          </el-radio-group>
          <div class="action-buttons">
            <el-button type="danger" @click="cancelOrder()">取消送出</el-button>
          </div>
        </div>

        <hr />

        <div class="action-bar">
          <div></div>
          <div class="action-buttons">
            <el-button
              v-if="isGetOutAvailable"
              type="warning"
              @click="passengerOff()"
            >
              乘客下車
            </el-button>
            <el-button type="danger" @click="deleteOrder()">封存訂單</el-button>
          </div>
        </div>
      </div>
    </el-form>

    <el-form ref="editOrderForm" class="border-container" :model="formData">
      <div class="order-info-section">
        <h2 class="title"><span>乘客資訊</span></h2>
        <div class="table-responsive">
          <table class="table table-hover">
            <tbody>
              <tr>
                <td>乘客</td>
                <td>{{ formData.name }}</td>
              </tr>
              <tr>
                <td>行政區</td>
                <td>{{ formData.area }}</td>
              </tr>
              <tr>
                <td>住家地址</td>
                <td>{{ formData.address }}</td>
              </tr>
              <tr>
                <td>聯絡人</td>
                <td>{{ formData.contactPerson || '無' }}</td>
              </tr>
              <tr>
                <td>住家電話</td>
                <td>{{ formData.telephoneNumber }}</td>
              </tr>
              <tr>
                <td>手機一</td>
                <td>{{ formData.firstMobilePhoneNumber || '無' }}</td>
              </tr>
              <tr>
                <td>手機二</td>
                <td>
                  {{ formData.secondMobilePhoneNumber || '無' }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="order-info-section">
        <h2 class="title"><span>即時資訊</span></h2>
        <div class="table-responsive">
          <table class="table table-hover">
            <tbody>
              <tr>
                <td>本月剩餘補助</td>
                <td>{{ formData.subsidyLastAmount || 0 }}</td>
              </tr>

              <tr>
                <td>社區式剩餘次數</td>
                <td>{{ formData.lastCommunityShuttleFrequency || 0 }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="order-info-section">
        <h2 class="title"><span>司機資訊</span></h2>
        <el-form-item label="司機">
          <template>
            <DriverSelector
              :driver="formData.driver"
              :preferParams="{ service: formData.service }"
              @driver-updated="setDriverFields($event)"
            />
          </template>
        </el-form-item>

        <el-form-item label="使用車牌">
          <DriverLicenseSelector
            :driver="formData.licenseNumber"
            placeholder="注意：英文大寫，所有字母為半形字"
            :preferParams="{
              service: formData.service,
              searchFields: 'license_number',
            }"
            @driver-license-updated="setDriverLicenseFields($event)"
          />
        </el-form-item>
      </div>

      <div class="order-info-section">
        <h2 class="title"><span>乘車資訊</span></h2>

        <el-form-item label="*派單方式">
          <el-select
            :value="String(formData.deliveryMethod)"
            @change="formData.deliveryMethod = $event"
            placeholder="必填"
          >
            <el-option
              v-for="item in deliveryMethodOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="*預定上車時間">
          <el-date-picker
            v-model="formData.estimateGetOnTime"
            type="datetime"
            placeholder="選擇上車時間"
            :picker-options="pickerOpt"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="*實際上車時間">
          <el-date-picker
            v-model="formData.getOnTime"
            type="datetime"
            placeholder="實際上車時間"
            :picker-options="pickerOpt"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="*實際下車時間">
          <el-date-picker
            v-model="formData.getOffTime"
            type="datetime"
            placeholder="實際下車時間"
            :picker-options="pickerOpt"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="上車地址">
          <el-autocomplete
            class="inline-input"
            v-model="formData.onLocation"
            :fetch-suggestions="handleTypeIn"
            placeholder="請輸入地址"
            highlight-first-item
            popper-class="wider-autocomplete"
            @select="handleLocation('onLocation', $event)"
          ></el-autocomplete>
          <el-button
            @click="fillUserAddressGps((e) => handleLocation('onLocation', e))"
            :disabled="!selectedUser || !selectedUser.address"
          >
            同地址
          </el-button>
          <el-button
            :disabled="!selectedHistoryAddress"
            @click="() => fillHistoryAddressGps('onLocation')"
          >
            歷史上車點
          </el-button>
        </el-form-item>

        <el-form-item label="上車經度">
          <el-input v-model="formData.onLocationGps[0]"></el-input>
          <label>上車緯度</label>
          <el-input v-model="formData.onLocationGps[1]"></el-input>
        </el-form-item>

        <el-form-item label="下車地址">
          <el-autocomplete
            class="inline-input"
            v-model="formData.offLocation"
            :fetch-suggestions="handleTypeIn"
            placeholder="請輸入地址"
            highlight-first-item
            popper-class="wider-autocomplete"
            @select="handleLocation('offLocation', $event)"
          ></el-autocomplete>
          <el-button
            @click="fillUserAddressGps((e) => handleLocation('offLocation', e))"
            :disabled="!selectedUser || !selectedUser.address"
          >
            同地址
          </el-button>
          <el-button
            :disabled="!selectedHistoryAddress"
            @click="() => fillHistoryAddressGps('offLocation')"
          >
            歷史下車點
          </el-button>
        </el-form-item>

        <el-form-item label="下車經度">
          <el-input v-model="formData.offLocationGps[0]"></el-input>
          <label>下車緯度</label>
          <el-input v-model="formData.offLocationGps[1]"></el-input>
        </el-form-item>

        <div v-if="historyAddressData.length > 0" class="history-address">
          <div class="table-responsive">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>地址</th>
                  <th>經度</th>
                  <th>緯度</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(geo, index) in historyAddressData"
                  :key="`geo-${index}`"
                  @click="selectedHistoryAddress = geo"
                  :class="{
                    'history-address--selected': geo === selectedHistoryAddress,
                  }"
                >
                  <td>{{ geo.address }}</td>
                  <td v-if="geo.gps">{{ geo.gps[0] || '--' }}</td>
                  <td v-if="geo.gps">{{ geo.gps[1] || '--' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <el-form-item label="乘客數">
          <el-input
            type="number"
            placeholder="請輸入"
            v-model="formData.seat"
          ></el-input>
        </el-form-item>

        <el-form-item label="偏好服務" v-if="formData.service">
          <el-checkbox-group v-model="formData.service">
            <el-checkbox
              v-for="service in teamAvailableService"
              :label="service.teamServiceId"
              :key="`service-${service.teamServiceId}`"
            >
              {{ service.name }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item label="客服備註">
          <el-input
            type="textarea"
            autosize
            placeholder="請輸入"
            v-model="formData.serviceNote"
          ></el-input>
        </el-form-item>
      </div>

      <div class="order-info-section">
        <h2 class="title"><span>費用資訊</span></h2>

        <el-form-item label="補助方式">
          <template>
            <el-select
              @change="onChangeSubsidy"
              :value="String(formData.subsidyMethod)"
              @input="$set(formData, 'subsidyMethod', $event)"
              placeholder="請選擇"
            >
              <el-option
                v-for="item in subsidyMethodOptions"
                :key="item.value.id"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
        </el-form-item>

        <el-form-item label="跳錶金額">
          <el-input
            placeholder="請輸入"
            v-model="formData.metreFare"
          ></el-input>
          <el-button @click="calculateSubsidyFare()">自動計算</el-button>
        </el-form-item>

        <el-form-item label="補助金額">
          <el-input
            placeholder="請輸入"
            disabled
            v-model="formData.subsidyFare"
          ></el-input>
        </el-form-item>

        <el-form-item label="實收金額">
          <el-input
            placeholder="請輸入"
            disabled
            v-model="formData.actualFare"
          ></el-input>
        </el-form-item>

        <el-form-item label="里程數">
          <el-input
            type="number"
            placeholder="請輸入"
            v-model="formData.milage"
          ></el-input>
        </el-form-item>
      </div>

      <div class="text-right">
        <el-button type="primary" @click="save()">確認</el-button>
        <el-button @click="resetFrom()">取消</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
const log = console.log
import _ from 'lodash'
import is from 'is_js'
import { defaultOption } from './defaultOption'
import coordinatePositioning from './_CoordinatePositioning'
import driverMixin from './_DriverMixin'
import longTermCareService from '@/API/longTermCareService'
import moment from 'moment'

export default {
  mixins: [coordinatePositioning, driverMixin],
  data() {
    return {
      defaultOption,
      historyAddressData: [],
      selectedHistoryAddress: null,
      selectedUser: null,
      teamAvailableService: [],
      formData: {
        service: [],
        driver: null,
        driverId: null,
        licenseNumber: null,
        onLocationGps: [],
        offLocationGps: [],
      },
      tempMeterFare: null,
      tempSubsidyFare: null,
      tempActualFare: null,
      availableUsers: [],
      pickerOpt: {
        disabledDate: (time) => {
          const SecondsOfDay = 60 * 60 * 24 * 1000
          return time.getTime() + SecondsOfDay < new Date().getTime()
        },
      },
      isClickAutoCal: false,
    }
  },
  mounted() {
    this.fetchTeamService()
  },
  computed: {
    isGetOutAvailable() {
      return [1, 2].indexOf(this.formData.orderStatus) !== -1
    },
    orderId() {
      return this.$route.params && this.$route.params.orderId
    },
    deliveryMethodOptions() {
      const excludeOptions = (opt) => {
        const { deliveryMethod, subsidyMethod } = this.formData

        if (Number(subsidyMethod) === 0 && Number(opt.value) === 1) return false
        if (Number(subsidyMethod) === 1 && Number(opt.value) === 0) return false

        return true
      }
      return this.defaultOption.deliveryMethodOptions.filter(excludeOptions)
    },
    subsidyMethodOptions() {
      const excludeOptions = (opt) => {
        const { deliveryMethod, subsidyMethod } = this.formData

        if (Number(deliveryMethod) === 0 && Number(opt.value) === 1)
          return false
        if (Number(deliveryMethod) === 1 && Number(opt.value) === 0)
          return false

        return true
      }
      return this.defaultOption.subsidyMethodOptions.filter(excludeOptions)
    },
  },
  created() {
    this.fetchOrder()
  },
  methods: {
    onChangeSubsidy(val) {
      this.isClickAutoCal = true
      // console.log(val)
    },
    fillHistoryAddressGps(fieldName) {
      const { address, gps } = this.selectedHistoryAddress
      const payload = { geo: { gps: { coordinates: gps }, address } }
      this.handleLocation(fieldName, payload)
      this.$set(this, 'selectedHistoryAddress', null)
    },
    fetchHistoryAddressByUser(userId) {
      longTermCareService.queryUserDetail(userId).then((raw) => {
        this.$set(
          this,
          'historyAddressData',
          _.uniqBy(
            raw.result.historyAddressData,
            (item) => `${item.address}+${item.gps}`,
          ),
        )
      })
    },
    fetchOrder() {
      const _reasonLookup = {
        乘客取消: 1,
        乘客爽約: 2,
      }

      longTermCareService
        .getOrderById(this.orderId)
        .then((raw) => {
          const formData = raw.result
          if (!formData.onLocationGps) formData.onLocationGps = []

          if (!formData.offLocationGps) formData.offLocationGps = []

          if (formData.cancelReason) formData.hasReason = 3
          if (_reasonLookup[formData.cancelReason])
            formData.hasReason = _reasonLookup[formData.cancelReason]
          let service = []
          for (let i = 0; i < formData.serviceList.length; i++) {
            service.push(formData.serviceList[i].teamServiceId)
          }
          this.$set(this, 'formData', {
            ...formData,
            service,
          })
          // console.log('raw.result', this.formData.service)

          this.selectedUser = {
            ...formData.userInformation,
          }

          // fetch history address when user changed
          this.fetchHistoryAddressByUser(
            formData.userInformation.longTermCareUserId,
          )
        })
        .catch(
          ({ data: { error } = {}, message }) =>
            this.$message.error(message || error.message) && this.back(),
        )
    },
    passengerOff() {
      longTermCareService
        .updateOrderStatus(this.orderId)
        .then(({ message }) => this.$message.success(message) && this.back())
        .catch(({ data: { error } = {}, message }) =>
          this.$message.error(message || error.message),
        )
    },
    cancelOrder() {
      const {
        orderId,
        formData: { cancelReason },
      } = this
      longTermCareService
        .cancelOrder(orderId, cancelReason)
        .then(({ message }) => this.$message.success(message) && this.back())
        .catch(({ data: { error } = {}, message }) =>
          this.$message.error(message || error.message),
        )
    },
    deleteOrder() {
      longTermCareService
        .deleteOrder(this.orderId)
        .then(({ message }) => this.$message.success(message) && this.back())
        .catch(({ data: { error } = {}, message }) =>
          this.$message.error(message || error.message),
        )
    },
    calculateSubsidyFare() {
      const id = this.formData.longTermCareUserId

      if (!id) return this.$message.error('long_term_care/order 沒提供 userId')

      const { subsidyMethod: subsidy_method, metreFare: metre_fare } =
        this.formData
      let time = moment(this.formData.estimateGetOnTime).format('YYYY-MM-DD')
      console.log('time', time)
      longTermCareService
        .getSubsidyAmount(id, { subsidy_method, metre_fare, time })
        .then(({ result = {}, message }) => {
          this.isClickAutoCal = false
          this.$message.success(message)
          const { subsidyFare, actualFare } = result
          this.$set(this.formData, 'subsidyFare', subsidyFare)
          this.tempSubsidyFare = subsidyFare
          this.tempActualFare = actualFare
          this.tempMeterFare = metre_fare
          this.$set(this.formData, 'actualFare', actualFare)
        })
        .catch(({ data: { error } }) => {
          const { metreFare } = this.formData
          this.$set(this.formData, 'subsidyFare', 0)
          this.$set(this.formData, 'actualFare', metreFare)
          this.$message.error(error.message)
        })
    },
    resetFrom() {
      this.formData = {}
      this.back()
    },
    back() {
      setTimeout(() => this.$router.go(-1), 500)
    },
    save() {
      if (this.isClickAutoCal) return this.$msg('請點選自動計算')
      let data = {}
      ;[
        'longTermCareUserId',
        'deliveryMethod',
        'estimateGetOnTime',
        'onLocation',
        'offLocation',
        'seat',
        'driverId',
        'licenseNumber',
        'subsidyMethod',
        // "metreFare",
        'onLocationGps',
        'offLocationGps',
        'getOnTime',
        'getOffTime',
        // "subsidyFare",
        // "actualFare",
        'milage',
        'serviceNote',
        /**/
      ].forEach((key) => {
        console.log(key)
        if (is.existy(this.formData[key])) {
          console.log('key', key)
          if (key === 'offLocationGps' && this.formData[key][0] === '') {
            data[key] = []
          } else {
            data[key] = this.formData[key]
          }
        }
      })
      if (this.tempSubsidyFare !== null) {
        data['subsidyFare'] = this.tempSubsidyFare
      }
      if (this.tempActualFare !== null) {
        data['actualFare'] = this.tempActualFare
      }
      if (this.tempMeterFare !== null) {
        data['metreFare'] = this.tempMeterFare
      }

      if (Array.isArray(this.formData['service'])) {
        data['service'] = _.filter(this.formData['service'], (val) => val)
      }
      longTermCareService
        .updateOrder(this.orderId, data)
        .then((data) => {
          this.$message.success(data.message)
          this.back()
          return data
        })
        .catch(({ data: { error } }) => this.$message.error(error.message))
    },
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name !== 'longTermOrderList') {
      this.$router.go(-2)
    }
    next()
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/longterm-care.scss';

.page-content {
  position: relative;
  max-width: 960px;
  width: 100%;
  margin: auto;
}
.el-form-item__row,
.el-form-item__row .el-form-item__content {
  position: relative;
  width: 100%;
  display: block;
}

.el-form-item__row .el-form-item__label {
  position: absolute;
  top: 0;
}

.el-form-item__content .el-input,
.el-form-item__content .el-textarea {
  display: inline-block;
  width: auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/longTermCare/EditOrderForm.vue